export enum DbAuthenticationMethod {
  WindowAuth = 'WindowAuthentication',
  EntraIDAuth = 'EntraIDIntegratedAuthentication',
  SQLServerAuth = 'SQLServerAuthentication',
}
